// extracted by mini-css-extract-plugin
export default {"RankingBar":"styles_RankingBar__Y5itf","rankingCaption":"styles_rankingCaption__Ll5VQ","statsContainer":"styles_statsContainer__vdd4N","statCaption":"styles_statCaption__hTFX3"};